<div id="appt-dtl-card">
  <div class="card">
    <div class="card-head" *ngIf="type!='REVIEW' && type!='DETAILS' && type!='PACKAGEPREVIEW' && type!='CONFIRMPACKAGE' && type!='SUBSERVICECONFIRM'">
        <div class="conatiner border-bottom">
        <p class="subtitle m-btm">{{'appt_dtl_ttl_appt_type'|translate:'LABELS'}}</p>
        <span class="font-default-small bold">
            <span class="appt-type" *ngIf="apptInfo['appointmentType'] === 'VIDEO' && !apptInfo['isOnspot']" >{{'appt_dtl_lbl_video_consultation'|translate:'LABELS'}}</span>
            <span class="appt-type" *ngIf="apptInfo['appointmentType'] === 'VIDEO' && apptInfo['isOnspot']" >{{'onspot_req_ttl_video_consult_onspot'|translate:'LABELS'}}</span>
            <span class="appt-type" *ngIf="apptInfo['appointmentType'] != 'VIDEO' && apptInfo['appointmentType'] != 'HC' && apptInfo['appointmentType'] != 'HP'" >{{'appt_dtl_lbl_clinic_consultation'|translate:'LABELS'}}</span>
            <span class="appt-type" *ngIf="apptInfo['appointmentType'] == 'HC'">{{'appt_dtl_lbl_home_care_consultation'|translate:'LABELS'}}</span>
            <span  class="appt-type" *ngIf="apptInfo['appointmentType'] == 'HP'">{{'appt_dtl_lbl_health_pkg'|translate:'LABELS'}}</span>
        </span>
        </div>
        <div class="card-content">
        <div>
            <p class="subtitle lbl">{{'appt_dtl_ttl_appt_for'|translate:'LABELS'}}</p>
            <div class="patient-details border-bottom">
            <div class="image">
                <app-person-avatar [url]="apptInfo['imageurl']"> </app-person-avatar>
            </div>
            <div class="partitioner-content">
                <div class="title">
                    {{apptInfo['personName'] ? apptInfo['personName']: (apptInfo['personname'] ? apptInfo['personname'] : "") }}
                </div>
                <div class="font-light-small">
                {{apptInfo['uhid']}}
                </div>
            </div>
            <div class="prim-ttl-txt bold a-center"  *ngIf="isEditApplicable" (click)="switchAction('PATIENT')">
                <img src="./assets/icons/health-package/Switch.svg">
            </div>
            </div>
        </div>
        <div *ngIf="apptInfo['appointmentType'] != 'HP'">
            <p class="subtitle lbl">{{'appt_dtl_ttl_consult_doc'|translate:'LABELS'}}</p>
            <div class="partitioner-details border-bottom">
            <div class="image">
                <app-practitioner-avatar
                [url]="(apptInfo['resourceId']|partitionerDetails:apptInfo['facilityId']:'resourceAvatarURL')">
                </app-practitioner-avatar>
            </div>
            <div class="partitioner-content">
                <div class="title">
                    <ng-container *ngIf="apptInfo.practitionerLocalName">
                        {{apptInfo.practitionerLocalName | translate : translateType : 'name'}}
                      </ng-container>
                      <ng-container *ngIf="!apptInfo.practitionerLocalName && apptInfo.practitionerName">
                        {{apptInfo.practitionerName}}
                      </ng-container>
                      <ng-container *ngIf="!apptInfo.practitionerLocalName && !apptInfo.practitionerName">
                        {{(apptInfo['resourceId']|partitionerDetails:apptInfo['facilityId']:'resourceName'| translate : translateType : 'name') || 'Doctor'}}
                      </ng-container>
                </div>
                <div class="font-light-small">
                    {{apptInfo['resourceId']|partitionerDetails: apptInfo['facilityId']:'specialityId' | specialityDetails: apptInfo['facilityId']:'specialityName'| translate : translateType : 'name'}}
                </div>
            </div>
            <div class="prim-ttl-txt bold a-center" *ngIf="scheduleCost">
                {{ scheduleCost['cc_cost'].value }} {{currency_code}} 
            </div>
            </div>
        </div>
        <div class="conatiner" *ngIf="apptInfo['appointmentType'] != 'HP'">
            <p class="subtitle m-btm">
                <span>{{'appt_dtl_ttl_appt_date_loc'|translate:'LABELS'}}</span>
            </p>
            <span class="font-default-small bold">
                <span  class="appt-date">
                    <app-appt-time type="DETAIL1" [time]="apptInfo['appointmentDateTime']" [sourceFormat]="'YYYY-MM-DD HH:mm'" [destinationFormat]="'ddd DD MMM YY, hh:mm a'" [showLocalTime]="('' | apptTime : 'CHECK': null:null: null: apptInfo['facilityId'])" [facilityId]="apptInfo['facilityId']"></app-appt-time>

                </span>
                <p class="r-mgn">
                    <span *ngIf="apptInfo['appointmentType'] != 'VIDEO' && apptInfo['appointmentType'] != 'HC'" >{{apptInfo['facilityId'] | facilityDetails : 'facilityName'| translate : 'LOCALE' : 'name' }}</span>
                    <span  *ngIf="apptInfo['appointmentType'] == 'HC'">{{apptInfo['homeCareServices']['location']['address'] }}</span>
                </p>
            </span>
        </div>
        <ng-container *ngIf="apptInfo['appointmentType'] == 'HP'">
            <div >
                <p class="subtitle lbl">{{'appt_dtl_ttl_services'|translate:'LABELS'}}</p>
                <div class="partitioner-details border-bottom">
                <div class="partitioner-content no-padding">
                    <div class="title">
                        <ng-container *ngIf="apptInfo.selectedPkg">
                            {{ apptInfo.selectedPkg.name | translate : 'LANGARRAY' : 'name'}}
                        </ng-container>
                    </div>
                    <!-- <div class="font-light-small">
                        {{apptInfo['resourceId']|partitionerDetails: apptInfo['facilityId']:'specialityId' | specialityDetails: apptInfo['facilityId']:'specialityName'| translate : translateType : 'name'}}
                    </div> -->
                </div>
                <div class="prim-ttl-txt bold a-center">
                    <span *ngIf="apptInfo.selectedFacility.controls.discountCharge">{{ apptInfo.selectedFacility.controls.discountCharge }} {{currency_code}} </span>
                    <span *ngIf="!apptInfo.selectedFacility.controls.discountCharge">{{ apptInfo.selectedFacility.controls.charge }} {{currency_code}} </span>
                </div>
                </div>
            </div>
            <div class="conatiner border-bottom" >
                <p class="subtitle m-btm">{{'appt_dtl_ttl_location'|translate:'LABELS'}}</p>
                <div class="font-default-small spc-btw bold">
                    <div class="r-mgn">
                        <span >{{apptInfo['selectedFacility']['facilityId'] | facilityDetails : 'facilityName'| translate : 'LOCALE' : 'name' }}</span>
                    </div>
                    <div class="a-center" *ngIf="isEditApplicable" (click)="switchAction('FACILITY')">
                        <img src="./assets/icons/health-package/edit.svg">
                    </div>
                </div>
            </div>
            <div class="conatiner"  >
                <p class="subtitle m-btm">{{'appt_dtl_ttl_appt_date'|translate:'LABELS'}}</p>
                <div class="font-default-small spc-btw bold">
                    <div class="r-mgn">
                        <span *ngIf="apptInfo['appointmentType'] == 'HP'">{{ apptInfo.selectedSlot.slot.date | moment : 'ddd DD MMM YYYY, '}} {{ apptInfo.selectedSlot.slot.slot | moment:'hh:mm a': 'HH:mm' }}</span>
                    </div>
                    <div class="a-center" *ngIf="isEditApplicable" (click)="switchAction('SLOT')">
                        <img src="./assets/icons/health-package/edit.svg">
                    </div>
                </div>
            </div>
        </ng-container>
        </div>
    </div>
    <div class="card-head" *ngIf="type=='REVIEW' || type=='DETAILS'">
      <div class="conatiner border-bottom" *ngIf="type=='DETAILS'">
        <p class="subtitle m-btm">{{'appt_dtl_ttl_appt_type'|translate:'LABELS'}}</p>
        <span class="font-default-small bold">
            <span  class="appt-type" *ngIf="apptInfo['appointmentType'] === 'VIDEO'" >{{'appt_dtl_lbl_video_consultation'|translate:'LABELS'}}</span>
            <span  class="appt-type" *ngIf="apptInfo['appointmentType'] != 'VIDEO' && apptInfo['appointmentType'] != 'HC' && apptInfo['appointmentType'] != 'HP'" >{{'appt_dtl_lbl_clinic_consultation'|translate:'LABELS'}}</span>
            <span   class="appt-type" *ngIf="apptInfo['appointmentType'] == 'HC'">{{'appt_dtl_lbl_home_care_consultation'|translate:'LABELS'}}</span>
            <span   class="appt-type" *ngIf="apptInfo['appointmentType'] == 'HP'">{{'appt_dtl_lbl_health_pkg'|translate:'LABELS'}}</span>
        </span>
      </div>
      <div class="card-content">
        <div>
            <p class="subtitle lbl">{{'appt_dtl_ttl_appt_for'|translate:'LABELS'}}</p>
            <div class="patient-details border-bottom">
            <div class="image">
                <app-person-avatar [url]="apptInfo.in['patient']['image']"> </app-person-avatar>
            </div>
            <div class="partitioner-content">
                <div class="title">
                    {{apptInfo.in['patient']['name']}}
                </div>
                <div class="font-light-small">
                    <ng-container *ngIf="!linkWithoutRelation">{{apptInfo.in['patient']['relation'] | translate : 'RELATION'}}</ng-container>
                    <ng-container *ngIf="linkWithoutRelation">{{apptInfo.in['patient']['id']}}</ng-container>
                </div>
            </div>
            <div class="prim-ttl-txt bold a-center" *ngIf="isEditApplicable"  (click)="switchAction('select_patient')">
                <img src="./assets/icons/health-package/Switch.svg">
            </div>
            </div>
        </div>
        <div *ngIf="apptInfo['appointmentType'] != 'HP'">
            <p class="subtitle lbl">{{'appt_dtl_ttl_consult_doc'|translate:'LABELS'}}</p>
            <div class="partitioner-details border-bottom">
            <div class="image">
                <app-practitioner-avatar
                [url]="apptInfo.in['practitioner']['resourceAvatarURL']">
                </app-practitioner-avatar>
            </div>
            <div class="partitioner-content">
                <div class="title">
                    <ng-container>
                        {{apptInfo.in['practitioner']['name'] | translate : translateType : 'name'}}
                      </ng-container>
                </div>
                <div class="font-light-small">
                  <ng-container *ngIf="apptInfo.in['speciality']['facilityId']">
                    {{ apptInfo.in['speciality']['id'] | specialityDetails: (apptInfo.in['speciality']['facilityId']?apptInfo.in['speciality']['facilityId'] :null) :'specialityName'| translate : translateType : 'name'}}
                  </ng-container>
                  <ng-container *ngIf="!apptInfo.in['speciality']['facilityId'] && apptInfo.in['speciality']['desc']">
                    {{apptInfo.in['speciality']?apptInfo.in['speciality']['desc']:''}}
                  </ng-container>
                </div>
            </div>
            <div class="prim-ttl-txt bold a-center"  *ngIf="scheduleCost && scheduleCost['cc_cost']">
                {{ scheduleCost['cc_cost'].value }} {{currency_code}} 
            </div>
            </div>
        </div>
        <div class="conatiner" *ngIf="apptInfo['appointmentType'] != 'HP'" style="position: relative;">
            <ng-container *ngIf="!fromSlotBlockPrompt">
                <p class="subtitle m-btm">
                    <span>{{'appt_dtl_ttl_appt_date_loc'|translate:'LABELS'}}</span>
                </p>
                <span class="font-default-small bold">
                    <span  class="appt-date">
                        <app-appt-time type="DETAIL1" [time]="apptInfo.in['slot']['date']+' '+apptInfo.in['slot']['slot']" [sourceFormat]="'YYYY-MM-DD HH:mm'" [destinationFormat]="'ddd DD MMM YY, hh:mm a'" [showLocalTime]="('' | apptTime : 'CHECK': null:null: null: apptInfo.in['facility']['facilityId'])" [facilityId]="apptInfo.in['facility']['facilityId']"></app-appt-time>
                    </span>
                    <p class="r-mgn">
                        <span *ngIf="apptInfo['appointmentType'] != 'VIDEO' && apptInfo['appointmentType'] != 'HC'" >{{apptInfo.in['facility']?(apptInfo.in['facility']['name'] | translate : translateType : 'name'):''}}</span>
                        <span  *ngIf="apptInfo['appointmentType'] == 'HC'">{{apptInfo['homeCareServices']['location']['address'] }}</span>
                    </p>
                </span>
                <div class="policy-expire-img-con" (click)="openPolicyExpirePop()" *ngIf="showpolicyInfo">
                    <img src="./assets/icons/error-info.svg">
                </div>
            </ng-container>
            <div *ngIf="fromSlotBlockPrompt" class="slot-with-block-err-con">
                <div>
                    <p class="subtitle m-btm">
                        <span>{{'appt_dtl_ttl_appt_date_loc'|translate:'LABELS'}}</span>
                    </p>
                    <span class="font-default-small bold">
                        <span  class="appt-date">
                            <app-appt-time type="DETAIL1" [time]="apptInfo.in['slot']['date']+' '+apptInfo.in['slot']['slot']" [sourceFormat]="'YYYY-MM-DD HH:mm'" [destinationFormat]="'ddd DD MMM YY, hh:mm a'" [showLocalTime]="('' | apptTime : 'CHECK': null:null: null: apptInfo.in['facility']['facilityId'])" [facilityId]="apptInfo.in['facility']['facilityId']"></app-appt-time>

                        </span>
                        <p class="r-mgn">
                            <span *ngIf="apptInfo['appointmentType'] != 'VIDEO' && apptInfo['appointmentType'] != 'HC'" >{{apptInfo.in['facility']?(apptInfo.in['facility']['name'] | translate : translateType : 'name'):''}}</span>
                            <span  *ngIf="apptInfo['appointmentType'] == 'HC'">{{apptInfo['homeCareServices']['location']['address'] }}</span>
                        </p>
                    </span>
                </div>
                <div class="error-img-con">
                    <img src="./assets/icons/error.svg" style="width: 1.3em;"> 
                </div>
            </div>
        </div>
        <div class="" [ngClass]="{ 'default-bg':  !enterReferral , 'referral-card': enterReferral}" *ngIf="isReferralApplicable">
            <p class="prim-ttl-txt " (click)="enterReferral = !enterReferral" *ngIf="!enterReferral">{{'appt_dtl_ttl_enter_referral_code'|translate:'LABELS'}}</p>
            <ng-container *ngIf="enterReferral">
                <p class="subtitle lbl">{{'appt_dtl_ttl_referral_code'|translate:'LABELS'}}</p>
                <div class="referral-input">
                    <input class="ref-input" [type]="refControl?refControl.type:'text'" (input)="onTextInput($event)" placeholder="{{ 'appt_dtl_placeholder_enter' | translate}}" [(ngModel)]="result.referralCode" (input)="competeAction()"
                    [minLength]="refControl?refControl.minLength:null"
                    [maxLength]="refControl?refControl.maxLength:null"/>
                    <div class="close float-right closeicon cursor-pointer" (click)="removeReferral()"
                        *ngIf="result.referralCode">
                        <img src="./assets/icons/close_grey.svg">
                    </div>
                </div>
            </ng-container>
        </div>

        <ng-container *ngIf="apptInfo['appointmentType'] == 'HP'">
            <div >
                <p class="subtitle lbl">{{'appt_dtl_ttl_services'|translate:'LABELS'}}</p>
                <div class="partitioner-details border-bottom">
                <div class="partitioner-content no-padding">
                    <div class="title">
                        <ng-container *ngIf="apptInfo.selectedPkg">
                            {{ apptInfo.selectedPkg.name | translate : 'LANGARRAY' : 'name'}}
                        </ng-container>
                    </div>
                    <!-- <div class="font-light-small">
                        {{apptInfo['resourceId']|partitionerDetails: apptInfo['facilityId']:'specialityId' | specialityDetails: apptInfo['facilityId']:'specialityName'| translate : translateType : 'name'}}
                    </div> -->
                </div>
                <div class="prim-ttl-txt bold a-center">
                    <span *ngIf="apptInfo.selectedFacility.controls.discountCharge">{{ apptInfo.selectedFacility.controls.discountCharge }} {{currency_code}} </span>
                    <span *ngIf="!apptInfo.selectedFacility.controls.discountCharge">{{ apptInfo.selectedFacility.controls.charge }} {{currency_code}} </span>
                </div>
                </div>
            </div>
            <div class="conatiner border-bottom" >
                <p class="subtitle m-btm">{{'appt_dtl_ttl_location'|translate:'LABELS'}}</p>
                <div class="font-default-small spc-btw bold">
                    <div class="r-mgn">
                        <span >{{apptInfo['selectedFacility']['facilityId'] | facilityDetails : 'facilityName'| translate : 'LOCALE' : 'name' }}</span>
                    </div>
                    <div class="a-center" *ngIf="isEditApplicable" (click)="switchAction('FACILITY')">
                        <img src="./assets/icons/health-package/edit.svg">
                    </div>
                </div>
            </div>
            <div class="conatiner"  >
                <p class="subtitle m-btm">{{'appt_dtl_ttl_appt_date'|translate:'LABELS'}}</p>
                <div class="font-default-small spc-btw bold">
                    <div class="r-mgn">
                        <span *ngIf="apptInfo['appointmentType'] == 'HP'">

                            <app-appt-time type="DETAIL1" [time]="apptInfo.in['slot']['date']+' '+apptInfo.in['slot']['slot']" [sourceFormat]="'YYYY-MM-DD HH:mm'" [destinationFormat]="'ddd DD MMM YY, hh:mm a'" [showLocalTime]="('' | apptTime : 'CHECK': null:null: null: apptInfo['selectedFacility']['facilityId'])" [facilityId]="apptInfo['selectedFacility']['facilityId']"></app-appt-time>
                        </span>
                    </div>
                    <div class="a-center" *ngIf="isEditApplicable" (click)="switchAction('SLOT')">
                        <img src="./assets/icons/health-package/edit.svg">
                    </div>
                </div>
            </div>
        </ng-container>
      </div>
    </div>
    <div class="card-head" *ngIf="type=='PACKAGEPREVIEW'">
      <div class="conatiner border-bottom" *ngIf="type=='PACKAGEPREVIEW' && !isBookingSubService">
        <p class="subtitle m-btm">{{'appt_dtl_ttl_appt_type'|translate:'LABELS'}}</p>
        <span class="font-default-small bold">
            <span   class="appt-type" *ngIf="apptInfo['flowType']== 'WELLNESS' || apptInfo?.selectedPkg?.packageDtls?.packageClassification == 'WELLNESS'">{{'appt_dtl_lbl_wellness_package'|translate:'LABELS'}}</span>
            <span   class="appt-type" *ngIf="apptInfo['flowType'] == 'PROMO' || apptInfo?.selectedPkg?.packageDtls?.packageClassification == 'PROMO'">{{'appt_dtl_lbl_promo_package'|translate:'LABELS'}}</span>
        </span>
      </div>
      <div [ngClass]="isBookingSubService ? 'pkg-card-content-subservice' : 'pkg-card-content'">
        <div>
            <p class="subtitle lbl">{{'appt_dtl_ttl_ordering_for'|translate:'LABELS'}}</p>
            <div class="patient-details border-bottom">
            <div class="image">
                <app-person-avatar [url]="apptInfo['selectedPatient']['imageurl']"> </app-person-avatar>
            </div>
            <div class="partitioner-content">
                <div class="title">
                    {{apptInfo['selectedPatient']['personname']}}
                </div>
                <div class="font-light-small">
                    <ng-container><span>{{apptInfo['selectedPatient']['uhid']}}</span><span>{{apptInfo['selectedPatient']['relationshiptype'] | translate : 'RELATION'}}</span></ng-container>
                    <!-- <ng-container *ngIf="linkWithoutRelation">{{apptInfo['selectedPatient']['id']}}</ng-container> -->
                </div>
            </div>
            <div class="prim-ttl-txt bold a-center" *ngIf="isEditApplicable && !isBookingSubService && !apptInfo?.reschedule"  (click)="switchAction('select_patient')">
                <img src="./assets/icons/health-package/Switch.svg">
            </div>
            </div>
        </div>
        <ng-container *ngIf="groupedServices && groupedServices.length > 0">
            <div class="service-card" *ngFor="let groupedService of groupedServices; let i = index">
              <div class="service-header" *ngIf="i === 0" [class.with-border]="footerApplicableStatus.includes(selectedPackage?.packageStatusFromTab)">
                <div class="left-col">
                  <p class="service-title">
                    {{ (groupedService.groupName) | translate:'LOCALE':'name' }}
                  </p>

                  <button class="included-services-btn" *ngIf="groupedService.isAppointmentGrouped"
                    (click)="showIncludedServices(groupedService)">
                    <img src="assets/icons/slot/info.svg" />
                    <span>{{ 'HEALTHPKG#SUBTITLE#TEXT#INCLUDEDSERVICES' | translate }}</span>
                  </button>
                </div>
              </div>
            </div>
        </ng-container>
        <div class="" [ngClass]="{ 'default-bg':  !enterReferral , 'referral-card': enterReferral}" *ngIf="isReferralApplicable">
            <p class="prim-ttl-txt " (click)="enterReferral = !enterReferral" *ngIf="!enterReferral">{{'appt_dtl_ttl_enter_referral_code'|translate:'LABELS'}}</p>
            <ng-container *ngIf="enterReferral">
                <p class="subtitle lbl">{{'appt_dtl_ttl_referral_code'|translate:'LABELS'}}</p>
                <div class="referral-input">
                    <input class="ref-input" [type]="refControl?refControl.type:'text'" (input)="onTextInput($event)" placeholder="{{ 'appt_dtl_placeholder_enter' | translate}}" [(ngModel)]="result.referralCode" (input)="competeAction()"
                    [minLength]="refControl?refControl.minLength:null"
                    [maxLength]="refControl?refControl.maxLength:null"/>
                    <div class="close float-right closeicon cursor-pointer" (click)="removeReferral()"
                        *ngIf="result.referralCode">
                        <img src="./assets/icons/close_grey.svg">
                    </div>
                </div>
            </ng-container>
        </div>

        <ng-container *ngIf="apptInfo['appointmentType'] == 'HP' || apptInfo['appointmentType'] == 'HEALTHPKG'">
            <div *ngIf="!isBookingSubService">
                <p class="subtitle lbl">{{'appt_dtl_ttl_package'|translate:'LABELS'}}</p>
                <div class="partitioner-details border-bottom">
                <div class="partitioner-content no-padding">
                    <div class="title">
                        <ng-container *ngIf="apptInfo.selectedPkg">
                            {{ apptInfo.selectedPkg.name | translate : 'LANGARRAY' : 'name'}}
                        </ng-container>
                    </div>
                    <ng-container *ngIf="apptInfo?.selectedPkg?.packageDtls?.servicesApplicable?.length > 0">
                      <div class="services-list">
                        <ng-container *ngFor="let services of apptInfo?.selectedPkg?.packageDtls.servicesApplicable">
                          <div class="service-item" *ngIf="(services | translate : 'PACKAGEOBJ') as service; else NOCONCEPT">
                            <img *ngIf="service._directiveRef?.imageUrl" [src]="service._directiveRef.imageUrl" class="service-icon" alt="Service Icon" />
                            <label class="service-label">{{ service.name | translate : 'LOCALE' : 'name' }}</label>
                          </div>
                          <ng-template #NOCONCEPT>
                            <div class="service-item">
                              <img src="./assets/icon/dashboard/package.svg" class="service-icon" alt="Default Icon" />
                              <label class="service-label">{{ services.directiveCode + ' - ' + services.conceptCode }}</label>
                            </div>
                          </ng-template>
                        </ng-container>
                      </div>
                    </ng-container>
                </div>
                <!-- <div class="prim-ttl-txt bold a-center">
                    <span *ngIf="apptInfo.selectedFacility.controls.discountCharge">{{ apptInfo.selectedFacility.controls.discountCharge }} {{currency_code}} </span>
                    <span *ngIf="!apptInfo.selectedFacility.controls.discountCharge">{{ apptInfo.selectedFacility.controls.charge }} {{currency_code}} </span>
                </div> -->
                </div>
            </div>
            <div class="conatiner border-bottom" >
                <p class="subtitle m-btm">{{'appt_dtl_ttl_facility'|translate:'LABELS'}}</p>
                <div class="font-default-small spc-btw bold">
                    <div class="r-mgn">
                        <span >{{apptInfo['selectedFacility']['facilityId'] | facilityDetails : 'facilityName'| translate : 'LOCALE' : 'name' }}</span>
                    </div>
                    <div class="a-center" *ngIf="isEditApplicable && !isBookingSubService && !apptInfo?.reschedule" (click)="switchAction('FACILITY')">
                        <img src="./assets/icons/health-package/edit.svg">
                    </div>
                </div>
            </div>
            <div class="conatiner"  >
                <p class="subtitle m-btm">{{'appt_dtl_ttl_first_service_appt_date_time'|translate:'LABELS'}}</p>
                <div class="font-default-small spc-btw bold">
                    <div class="r-mgn">
                        <span *ngIf="apptInfo['appointmentType'] == 'HP' || apptInfo['appointmentType'] == 'HEALTHPKG'">

                            <app-appt-time type="DETAIL1" [time]="apptInfo['selectedSlot']['slot']['date']+' '+apptInfo['selectedSlot']['slot']['slot']" [sourceFormat]="'YYYY-MM-DD HH:mm'" [destinationFormat]="'ddd DD MMM YY, hh:mm a'" [showLocalTime]="('' | apptTime : 'CHECK': null:null: null: apptInfo['selectedFacility']['facilityId'])" [facilityId]="apptInfo['selectedFacility']['facilityId']"></app-appt-time>
                        </span>
                    </div>
                    <div class="a-center" *ngIf="isEditApplicable && !isBookingSubService && !apptInfo?.reschedule" (click)="switchAction('SLOT')">
                        <img src="./assets/icons/health-package/edit.svg">
                    </div>
                </div>
            </div>
        </ng-container>
      </div>
    </div>
    <div class="card-head" *ngIf="type=='CONFIRMPACKAGE'">
      <div class="card-content">
        <div>
            <p class="subtitle lbl">{{'appt_dtl_ttl_ordering_for'|translate:'LABELS'}}</p>
            <div class="patient-details border-bottom">
            <div class="image">
                <app-person-avatar [url]="apptInfo?.patientDetails?.imageurl"> </app-person-avatar>
            </div>
            <div class="partitioner-content">
                <div class="title">
                    {{apptInfo['patientName']}}
                </div>
                <div class="font-light-small">
                    <ng-container><span>{{apptInfo?.patientDetails?.uhid}}</span><span>{{apptInfo?.patientDetails?.relationshiptype | translate : 'RELATION'}}</span></ng-container>
                    <!-- <ng-container *ngIf="linkWithoutRelation">{{apptInfo['selectedPatient']['id']}}</ng-container> -->
                </div>
            </div>
            </div>
        </div>

        <ng-container>
            <div >
                <p class="subtitle lbl">{{'appt_dtl_ttl_package'|translate:'LABELS'}}</p>
                <div class="partitioner-details border-bottom">
                <div class="partitioner-content no-padding">
                    <div class="title">
                        <ng-container *ngIf="apptInfo?.packageDetails?.conceptDesc">
                            {{ apptInfo?.packageDetails?.conceptDesc | translate : 'LANGARRAY' : 'name'}}
                        </ng-container>
                    </div>
                    <ng-container *ngIf="apptInfo?.packageDetails?.serviceToBook?.length > 0">
                      <div class="services-list">
                        <ng-container *ngFor="let services of apptInfo?.packageDetails?.serviceToBook">
                          <div class="service-item" *ngIf="(services | translate : 'PACKAGEOBJ') as service; else NOCONCEPT">
                            <img *ngIf="service._directiveRef?.imageUrl" [src]="service?._directiveRef?.imageUrl" class="service-icon" alt="Service Icon" />
                            <label class="service-label">{{ service.name | translate : 'LOCALE' : 'name' }}</label>
                          </div>
                          <ng-template #NOCONCEPT>
                            <div class="service-item">
                              <img src="./assets/icon/dashboard/package.svg" class="service-icon" alt="Default Icon" />
                              <label class="service-label">{{ services.directiveCode + ' - ' + services.conceptCode }}</label>
                            </div>
                          </ng-template>
                        </ng-container>
                      </div>
                    </ng-container>
                </div>
                <!-- <div class="prim-ttl-txt bold a-center">
                    <span *ngIf="apptInfo.selectedFacility.controls.discountCharge">{{ apptInfo.selectedFacility.controls.discountCharge }} {{currency_code}} </span>
                    <span *ngIf="!apptInfo.selectedFacility.controls.discountCharge">{{ apptInfo.selectedFacility.controls.charge }} {{currency_code}} </span>
                </div> -->
                </div>
            </div>
            <div class="conatiner border-bottom" >
                <p class="subtitle m-btm">{{'appt_dtl_ttl_facility'|translate:'LABELS'}}</p>
                <div class="font-default-small spc-btw bold">
                    <div class="r-mgn">
                        <span >{{apptInfo?.facilityId | facilityDetails : 'facilityName'| translate : 'LOCALE' : 'name' }}</span>
                    </div>
                </div>
            </div>
            <div class="conatiner">
                <p class="subtitle m-btm">{{'appt_dtl_ttl_first_service_appt_date_time'|translate:'LABELS'}}</p>
                <div class="font-default-small spc-btw bold">
                    <div class="r-mgn">
                        <span>
                            <app-appt-time type="DETAIL1" [time]="apptInfo?.apptDateTime" [sourceFormat]="'YYYY-MM-DD HH:mm'" [destinationFormat]="'ddd DD MMM YY, hh:mm a'" [showLocalTime]="('' | apptTime : 'CHECK': null:null: null: apptInfo?.facilityId)" [facilityId]="apptInfo?.facilityId"></app-appt-time>
                        </span>
                    </div>
                </div>
            </div>
        </ng-container>
      </div>
    </div>
    <div class="card-head" *ngIf="type=='SUBSERVICECONFIRM'">
      <div class="card-content">
        <div *ngIf="apptInfo?.selectedPatient as patient">
            <p class="subtitle lbl">{{'appt_dtl_ttl_ordering_for'|translate:'LABELS'}}</p>
            <div class="patient-details border-bottom">
            <div class="image">
                <app-person-avatar [url]="patient?.imageurl"> </app-person-avatar>
            </div>
            <div class="partitioner-content">
                <div class="title">
                    {{patient?.personname}}
                </div>
                <div class="font-light-small">
                    <ng-container><span>{{patient?.uhid}}</span><span>{{patient?.relationshiptype | translate : 'RELATION'}}</span></ng-container>
                </div>
            </div>
            <div class="prim-ttl-txt bold a-center" *ngIf="isEditApplicable && !isBookingSubService"  (click)="switchAction('select_patient')">
                <img src="./assets/icons/health-package/Switch.svg">
            </div>
            </div>
        </div>
        <div class="service-card" *ngIf="apptInfo?.selectedPkg">
          <div class="service-header" [class.with-border]="footerApplicableStatus.includes(selectedPackage?.packageStatusFromTab)">
            <div class="left-col">
              <p class="service-title">
                {{ apptInfo?.selectedPkg?.name | translate : 'LANGARRAY' : 'name' }}
              </p>
            </div>
          </div>
        </div>

        <ng-container *ngIf="apptInfo['appointmentType'] == 'HP' || apptInfo['appointmentType'] == 'HEALTHPKG'">
            <div class="conatiner border-bottom" >
                <p class="subtitle m-btm">{{'appt_dtl_ttl_facility'|translate:'LABELS'}}</p>
                <div class="font-default-small spc-btw bold">
                    <div class="r-mgn">
                        <span >{{apptInfo['selectedFacility']['facilityId'] | facilityDetails : 'facilityName'| translate : 'LOCALE' : 'name' }}</span>
                    </div>
                </div>
            </div>
            <div class="conatiner"  >
                <p class="subtitle m-btm">{{'appt_dtl_ttl_first_service_appt_date_time'|translate:'LABELS'}}</p>
                <div class="font-default-small spc-btw bold">
                    <div class="r-mgn">
                        <span *ngIf="apptInfo['appointmentType'] == 'HP' || apptInfo['appointmentType'] == 'HEALTHPKG'">

                            <app-appt-time type="DETAIL1" [time]="apptInfo['selectedSlot']['slot']['date']+' '+apptInfo['selectedSlot']['slot']['slot']" [sourceFormat]="'YYYY-MM-DD HH:mm'" [destinationFormat]="'ddd DD MMM YY, hh:mm a'" [showLocalTime]="('' | apptTime : 'CHECK': null:null: null: apptInfo['selectedFacility']['facilityId'])" [facilityId]="apptInfo['selectedFacility']['facilityId']"></app-appt-time>
                        </span>
                    </div>
                </div>
            </div>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="info-box" *ngIf="type=='CONFIRMPACKAGE'">
    <img src="assets/icons/packages/Info.svg" alt="Info" />
    <p>{{'view_active_pkg_details' | translate}}
        <span (click)="openPackageDetail()">{{"view_active_pkg_details_click_here" | translate}}</span>
    </p>
  </div>
</div>


<app-service-included *ngIf="showServiceIncludedModal" [selectedPackage]="selectedPackage" [groupedService]="selectedGrpService" [isServiceIncluded]="true" (click)="closeServiceModal()"></app-service-included>